import { Locale } from '@clearverify/constants';
export const numberWithCommas = (number, returnEmptyStringIfNill = false) => {
    if (!number) {
        return returnEmptyStringIfNill ? '' : '0';
    }
    return Number(number).toLocaleString(Locale.US, { maximumFractionDigits: 2 });
};
//# sourceMappingURL=number.js.map